
import { defineComponent, ref } from "@vue/runtime-core"

export default defineComponent({
  name: "faq",
  setup() {
    const contentList = ref<Array<any>>([])
    const isActive = ref<number | null>(null)
    const beforePicker = ref<number | null>(null)
    const ListWrapper = ref<HTMLDivElement | null>(null)

    contentList.value = [
      {
        Title: "오토콜 서비스가 무엇인가요?",
        Contents:
          "자동차에 부착된 개인 휴대폰 번호를 대량 수집해 이를 이용한 범죄(보이스피싱, 스미싱) 사례가 늘어나고 있습니다. 특히 여성 운전자의 경우 차량에 남긴 전화번호가 악용되어 스토킹에 노출되어 악용되는 사건도 발생하였습니다. 이와 같은 피해를 미연에 방지할 수 있도록 호출자와 운전자 간 휴대폰 번호를 노출하지 않고, 차량번호만으로도 운전자를 호출할 수 있는 서비스입니다.",
      },
      {
        Title: "서비스 가입은 어디서 하나요?",
        Contents:
          "서비스 가입은 아래와 같이 3가지 채널에서 가입이 가능합니다.\n1) 오토콜 홈페이지(https://www.autocall.ai)에서 [서비스 가입]을 통해 가입이 가능합니다.\n2) 1566-5382 대표번호로 전화하신 후에 보이는 ARS의 [서비스 가입 버튼] 또는 말하는/누르는 ARS에서 4번 누르시면 가입이 가능합니다.\n3) 구글 플레이 스토어 또는 앱스토어를 통해 AI 오토콜 APP을 다운로드하신 후 APP에서 가입이 가능합니다.",
      },
      {
        Title: "상세한 가입 절차가 어떻게 되나요?",
        Contents:
          "오토콜 서비스는 가입자 휴대폰 번호와 차량번호를 결합하여 연결, 착신하는 방식이므로 서비스 가입 시 가입자 휴대폰 번호와 차량번호를 필수로 등록해야 합니다. 정보 등록 및 서비스 이용약관 동의에 하시면 가입이 완료됩니다.",
      },
      {
        Title: "오토콜은 호출자와 운전자가 직접 통화하는 방식인가요?",
        Contents:
          "아니오, 호출자와 운전자 모두 ARS 중개 서버를 통해 호출 또는 응답이 되는 방식입니다. 만약 차량을 즉시 이동할 수 없거나 불가피하게 양자 간 통화가 필요한 경우 선택적으로 직접 통화를 할 수 있습니다. 직접 통화를 하더라도 프라이버시 보호를 위해 운전자-호출자 휴대폰 번호는 노출되지 않습니다.",
      },
      {
        Title: "서비스 해지는 어떻게 하나요?",
        Contents: "오토콜 홈페이지(https://www.autocall.ai)에서 [서비스 해지]를 통해 서비스 해지가 가능합니다.",
      },
    ]

    const openDetail = (idx: number) => {
      isActive.value === idx ? (isActive.value = null) : (isActive.value = idx)
      setTimeout(() => {
        let activeElement = document.getElementsByClassName("box-text")[idx] as HTMLBodyElement
        let setElement = document.getElementsByClassName("active-box")[0] as HTMLBodyElement

        if (beforePicker.value != null) {
          let clearElement = document.getElementsByClassName("content-box")[beforePicker.value] as HTMLBodyElement
          clearElement.style.height = "0px"
        }
        if (isActive.value === idx) {
          setElement.style.height = `${activeElement.offsetHeight}px`
        }
        beforePicker.value = idx
      }, 100)
    }

    return {
      contentList,
      ListWrapper,
      openDetail,
      isActive,
    }
  },
})
